export default __webpack_public_path__ + "3e2d5055af02bec9e76d89e6f9993b01.svg";